const formatTime = date => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()

  return `${year}-${month}-${day}` + ' ' + [hour, minute, second].map(formatNumber).join(':')

  // return `${year}年${formatNumber(month)}月${formatNumber(day)}日` + ' ' + [hour, minute, second].map(formatNumber).join(':')

  // return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}

const formatNumber = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

export default formatTime


//////////////////
// WEBPACK FOOTER
// ./utils/formatDate.js
// module id = Fjf1
// module chunks = 2